import React from 'react';
import { cn } from '../../utils/utils';
export const SkeletonCardTotalItem = () => {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex w-full border-gray-200 bg-white p-8 rounded-3xl"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-1 flex-col justify-between gap-12"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-[20px] w-40 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-10 w-32 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-[20px] w-[20px] rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-[20px] w-12 rounded-full bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-[20px] w-28 rounded-full bg-slate-200 animate-pulse"
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "ml-4 flex w-20 justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-16 w-16 rounded-full bg-slate-200 animate-pulse"
    })));
};
export default function SkeletonCardTotalList({ className, length = 4 }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('grid grid-cols-4 gap-4', className)
    }, new Array(length).fill(0).map((_, index) => /*#__PURE__*/ React.createElement(SkeletonCardTotalItem, {
        key: index
    })));
}
